import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _values from "lodash/values";
/* eslint-disable func-names */
import React from 'react';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';
import { Link, Title, Type } from '@nerdwallet/currency';
import Chiclet from '@nerdwallet/react-chiclet';
import { setTrk, TrkElement, TrkTag } from '@nerdwallet/nw-client-lib/trk-helper';
import Image from '@nerdwallet/react-image';
import BestOfBadgeIcon from './best-of-badge-icon';
import { IMAGE_RESIZABLE_ROOT } from './lib/utils';
import { PREHEADER_TRK_LOCATION, PREHEADER_TYPE, SENTIMENT_COLOR, SENTIMENT_TYPE } from './lib/constants';
import styles from "./marketplace-product-card.module.css";
import ketoStyles from "./keto-product-card/keto-product-card.module.css";
export { PREHEADER_TYPE, SENTIMENT_TYPE };
var BEST_OF_2022_ICON_PATH = "".concat(IMAGE_RESIZABLE_ROOT, ",width=50/cdn/credit-cards/icons/best-of-2022.png");
var Preheader = function Preheader(_ref) {
  var _params, _classNames2;
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$isKetoCard = _ref.isKetoCard,
    isKetoCard = _ref$isKetoCard === void 0 ? false : _ref$isKetoCard,
    _ref$sentiment = _ref.sentiment,
    sentiment = _ref$sentiment === void 0 ? SENTIMENT_TYPE.NEUTRAL : _ref$sentiment,
    text = _ref.text,
    title = _ref.title,
    trkTaxonomy = _ref.trkTaxonomy,
    trkPageType = _ref.trkPageType,
    type = _ref.type,
    url = _ref.url;
  if (!text) {
    return null;
  }
  var trkLocation = type === PREHEADER_TYPE.BADGE ? PREHEADER_TRK_LOCATION.BEST_OF_BADGE : PREHEADER_TRK_LOCATION.PREHEADER;
  var preheaderHref = url && setTrk({
    url: url,
    taxonomy: trkTaxonomy,
    params: (_params = {}, _defineProperty(_params, TrkTag.location, trkLocation), _defineProperty(_params, TrkTag.copy, text), _defineProperty(_params, TrkTag.element, TrkElement.button), _defineProperty(_params, TrkTag.pageType, trkPageType), _params)
  });
  var styledText = /*#__PURE__*/React.createElement(Title, {
    size: "small",
    className: classNames(classes('color-green-dark'), styles.preheaderText)
  }, text);
  var preheaderContent = function preheaderContent() {
    switch (type) {
      case PREHEADER_TYPE.DECORATED_TEXT:
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Chiclet, {
          text: text,
          color: SENTIMENT_COLOR[sentiment]
        }));
      case PREHEADER_TYPE.PLAIN_TEXT:
        return /*#__PURE__*/React.createElement(Type, {
          size: 1,
          className: classNames(_defineProperty({}, styles.preheaderPlainText, !isKetoCard))
        }, text);
      case PREHEADER_TYPE.BADGE_2022:
        return /*#__PURE__*/React.createElement(Type, {
          size: 2,
          className: styles.preheaderBadge2022Text
        }, text);
      case PREHEADER_TYPE.BADGE_2024:
        return /*#__PURE__*/React.createElement(Type, {
          size: 2,
          bold: true,
          className: classNames(classes('color-green-dark'), styles.preheaderText)
        }, text, "\xA02024");
      case PREHEADER_TYPE.BADGE_AWARDS:
        return /*#__PURE__*/React.createElement(Type, {
          size: 2,
          bold: true,
          className: classNames(classes('color-green-dark'), styles.preheaderText)
        }, text);
      case PREHEADER_TYPE.BADGE:
      default:
        return styledText;
    }
  };
  var preheaderIcon = function preheaderIcon() {
    switch (type) {
      case PREHEADER_TYPE.BADGE_2022:
        return /*#__PURE__*/React.createElement("div", {
          className: styles.preheaderBadge2022Icon
        }, /*#__PURE__*/React.createElement(Image, {
          backgroundColor: "#fff",
          alt: "Best of 2022 Award",
          className: styles.awardIcon,
          naturalHeight: 66,
          naturalWidth: 50,
          src: BEST_OF_2022_ICON_PATH
        }));
      case PREHEADER_TYPE.BADGE_2024:
        return /*#__PURE__*/React.createElement(BestOfBadgeIcon, {
          title: title,
          className: styles.icon
        });
      case PREHEADER_TYPE.BADGE_AWARDS:
        return /*#__PURE__*/React.createElement(BestOfBadgeIcon, {
          title: title,
          className: styles.icon
        });
      case PREHEADER_TYPE.BADGE:
        return /*#__PURE__*/React.createElement(BestOfBadgeIcon, {
          title: title,
          className: styles.icon
        });
      default:
        return null;
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames((_classNames2 = {}, _defineProperty(_classNames2, "".concat(styles.preheaderWrapper, " ").concat(styles.preheaderPlainText), !isKetoCard), _defineProperty(_classNames2, ketoStyles.ketopreheaderWrapper, isKetoCard), _classNames2))
  }, preheaderHref ? /*#__PURE__*/React.createElement(Link, {
    href: preheaderHref,
    className: styles.preheaderIconLink
  }, preheaderIcon()) : preheaderIcon(), preheaderHref ? /*#__PURE__*/React.createElement(Link, {
    href: preheaderHref
  }, preheaderContent()) : preheaderContent()));
};
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
  var PropTypes = require('prop-types');
  Preheader.propTypes = _objectSpread(_objectSpread({}, BestOfBadgeIcon.propTypes), {}, {
    className: PropTypes.string,
    isKetoCard: PropTypes.bool,
    sentiment: PropTypes.oneOf(_values(SENTIMENT_TYPE)),
    text: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired
  });
}
export default Preheader;